"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import { TeaserBar } from "~/components/common/teaserbar-eon/teaserbar-eon";
import PageSkeleton from "~/components/page-skeleton";
import { buttonVariants } from "~/components/ui/button-eon";
import { useLanguage } from "~/translations/loader/use-language";
export default function NotFound() {
  const $ = _c(15);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative aspect-square w-full max-w-sm"><CustomImage alt="" className="object-contain" fill={true} sizes="384px" src="images/page-404.png" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.page_404_headline) {
    t1 = <h1 className="font-bold text-3xl md:text-4xl">{t.page_404_headline}</h1>;
    $[1] = t.page_404_headline;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.page_404_copytext) {
    t2 = <p className="text-lg text-muted-foreground">{t.page_404_copytext}</p>;
    $[3] = t.page_404_copytext;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(buttonVariants({
      variant: "default"
    }));
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.page_404_goHome) {
    t4 = <CustomLink className={t3} href="/">{t.page_404_goHome}</CustomLink>;
    $[6] = t.page_404_goHome;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 px-6 py-16 text-center md:py-24">{t0}{t1}{t2}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TeaserBar />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <PageSkeleton>{t5}{t6}</PageSkeleton>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}